export default __webpack_public_path__ + "static/media/pradco_logo.cc3641a8.png";